"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const funtions_1 = require("../../funtions");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const renderTextContent = (headItem, item, progressTime, isTablet, isTeacher, isPrevious, goToSpareLive) => {
    switch (headItem.title) {
        case 'participant':
            return (react_1.default.createElement("span", null,
                item.attendances || 0,
                "\uBA85"));
        case 'dateAndParticipant':
            return (react_1.default.createElement("div", { className: "overText" },
                react_1.default.createElement("span", { style: { color: Colors_1.Colors.light_grey } }, (0, moment_1.default)(item.start_time).format('YYYY-MM-DD HH:mm')),
                '   ',
                react_1.default.createElement("span", null,
                    item.attendances || 0,
                    "\uBA85")));
        case 'status':
            if (isTeacher || progressTime) {
                if (item.status === 'closed')
                    return isPrevious ? (react_1.default.createElement("p", { style: {
                            fontSize: isTablet ? 14 : 12,
                            lineHeight: isTablet ? '21px' : '18px',
                            color: Colors_1.Colors.black,
                        } }, "\uC885\uB8CC")) : null;
                if (item.spare_live) {
                    return (react_1.default.createElement("div", { className: 'reservation-btn-wrap' },
                        react_1.default.createElement(common_1.Button, { className: "reservation-btn", text: "\uC785\uC7A5", onClick: () => (0, funtions_1.goToConference)(item.id) }),
                        react_1.default.createElement(common_1.Button, { className: "reservation-btn spare-btn", text: "\uC608\uBE44", onClick: () => goToSpareLive && goToSpareLive() })));
                }
                else {
                    return (react_1.default.createElement(common_1.Button, { className: "reservation-btn", text: "\uC785\uC7A5", onClick: () => (0, funtions_1.goToConference)(item.id) }));
                }
            }
            return (react_1.default.createElement("p", { className: "contents overText2", style: { color: Colors_1.Colors.black } }, i18next_1.default.t(`conference.${item[headItem.title]}`)));
        case 'title':
            return react_1.default.createElement("p", { className: "big overText2" }, item[headItem.title]);
        case 'dutaionTime':
            return (react_1.default.createElement("p", { className: "desc overText2" },
                (0, moment_1.default)(item['start_time']).format('YYYY-MM-DD HH:mm'),
                " ",
                item.progress_duration,
                "\uBD84 (",
                Math.floor(item.pre_entering_duration),
                "\uBD84 \uC804 \uC785\uC7A5)"));
        case 'start_time':
            return (react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD, HH:mm')));
        case 'classDate':
            return react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('YYYY-MM-DD'));
        case 'classTime':
            return react_1.default.createElement("p", { className: "overText2" }, (0, moment_1.default)(item[headItem.title]).format('HH:mm'));
        case 'type':
            return react_1.default.createElement("p", { className: "overText2" }, i18next_1.default.t(`conference.${item[headItem.title]}`));
        case 'progress_duration':
            return (react_1.default.createElement("p", { className: "overText2" }, `${item.progress_duration}분 ${item.progress_duration >= 60
                ? `(${Math.floor(item.progress_duration / 60)}시간${item.progress_duration % 60 !== 0
                    ? `${item.progress_duration % 60}분`
                    : ''})`
                : ''}`));
        case 'qna_managers_id':
            return react_1.default.createElement("p", { className: "overText2" }, item.qna_managers?.length ? '진행' : '-');
        case 'members':
            return react_1.default.createElement("p", { className: "overText2" }, `${item.members} / ${item.members.length}명`);
        default:
            return react_1.default.createElement("p", { className: "desc overText2" }, item[headItem.title]);
    }
};
const ReservationItem = ({ item, styles, isMobile, isAttendance, isTeacher, isClosed, tableReadDataKeys, handlerOneDel, savePreviousPage, isPrevious, goToSpareLive, }) => {
    const { isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    // 상세 페이지로 이동
    const handlerDetailPage = (id, isModify = false) => {
        if (!isAttendance)
            savePreviousPage();
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: isModify ? 'modify' : 'detail',
            id,
            props: isAttendance && isMobile ? item : undefined,
        });
    };
    const progressTime = (0, moment_1.default)().isBetween((0, moment_1.default)(item.start_time).subtract(item.pre_entering_duration, 'minutes'), (0, moment_1.default)(item.start_time).add(item.progress_duration, 'minutes'));
    const renderMobileView = () => tableReadDataKeys.map((headItem, index) => {
        return (react_1.default.createElement("div", { key: headItem.title, className: "mobile-item-wrap", style: { width: '100%' } },
            headItem.title === 'etc' && isTeacher && (react_1.default.createElement("div", { className: "flex row ", style: { gap: 6, position: 'absolute', right: '10px', top: '12px' } },
                item.status === 'booked' && !progressTime && (react_1.default.createElement(common_1.Button, { option: {
                        buttonAfterIcon: {
                            show: true,
                            name: 'edit',
                            color: Colors_1.Colors.dark_blue,
                            size: 15,
                        },
                    }, onClick: () => handlerDetailPage(item.id, true) })),
                item.status !== 'held' && !progressTime && (react_1.default.createElement(common_1.Button, { option: {
                        buttonAfterIcon: {
                            show: true,
                            name: 'delete',
                            size: 15,
                        },
                    }, onClick: () => handlerOneDel(item.id) })))),
            headItem.title === 'status' && (react_1.default.createElement("div", { className: "flex row ", style: isTeacher
                    ? {
                        // 교사: 입장 버튼을 정보 반대편(우측) 세로 중앙에 배치(데스크탑 배치와 일관).
                        // 기존엔 일반 흐름 첫 항목이라 정보 위(좌상단)에 쌓였다.
                        gap: 6,
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }
                    : {
                        width: 60,
                        gap: 6,
                        position: 'absolute',
                        right: '10px',
                        top: progressTime ? item.spare_live ? '20px' : '38px' : '45px',
                        justifyContent: 'center',
                    } }, renderTextContent(headItem, item, progressTime, isTablet, isTeacher, isPrevious, goToSpareLive))),
            react_1.default.createElement("div", { className: `${headItem.title} ${headItem.title === 'start_time' ? 'desc' : ''}`, key: index, onClick: !isTeacher ||
                    (!isClosed && headItem.title === 'status') ||
                    headItem.title === 'etc'
                    ? undefined
                    : () => handlerDetailPage(item.id) }, !(headItem.title === 'status') &&
                renderTextContent(headItem, item, progressTime, isTablet, isTeacher, isPrevious, goToSpareLive))));
    });
    const renderDesktopView = () => tableReadDataKeys.map((headItem, index) => (react_1.default.createElement("div", { className: `${headItem.title} reservation-item`, key: headItem.title + index, style: {
            flex: headItem.space,
            ...(headItem.minWidth && { minWidth: headItem.minWidth }),
            ...styles?.bodyItem,
            overflow: headItem.title === 'status' ? 'visible' : 'hidden',
            cursor: !isAttendance && (!isTeacher || (!isClosed && headItem.title === 'status'))
                ? 'default'
                : 'pointer',
            ...(headItem.title === 'status' && { pointerEvents: 'auto' }),
        }, onClick: !isTeacher ||
            (!isClosed && headItem.title === 'status') ||
            headItem.title === 'etc'
            ? undefined
            : () => handlerDetailPage(item.id) }, headItem.title === 'etc' ? (react_1.default.createElement("div", { className: "flex row", style: { gap: 10 } },
        item.status === 'booked' && !progressTime && (react_1.default.createElement(common_1.Button, { option: {
                buttonAfterIcon: {
                    show: true,
                    name: 'edit',
                    color: Colors_1.Colors.dark_blue,
                    size: 20,
                },
            }, onClick: () => handlerDetailPage(item.id, true) })),
        item.status !== 'held' && !progressTime && (react_1.default.createElement(common_1.Button, { option: {
                buttonAfterIcon: {
                    show: true,
                    name: 'delete',
                    color: Colors_1.Colors.pink,
                    size: 20,
                },
            }, onClick: () => handlerOneDel(item.id) })))) : (react_1.default.createElement(react_1.default.Fragment, null, renderTextContent(headItem, item, progressTime, isTablet, isTeacher, isPrevious, goToSpareLive))))));
    if (!item)
        return null;
    if (isMobile)
        return react_1.default.createElement(react_1.default.Fragment, null, renderMobileView());
    return react_1.default.createElement(react_1.default.Fragment, null, renderDesktopView());
};
exports.default = react_1.default.memo(ReservationItem);
